import React from 'react';
import { Box, useRadio } from '@chakra-ui/react';

const FontToggle = props => {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="md"
        boxShadow="md"
        textStyle={
          props.children === 'Serif' ? 'articleSerifText' : 'articleSansText'
        }
        _checked={{
          bg: 'teal.600',
          color: 'white',
          borderColor: 'teal.600',
        }}
        _focus={{
          boxShadow: 'outline',
        }}
        px={4}
        py={2}
      >
        {props.children}
      </Box>
    </Box>
  );
};

export default FontToggle;
